"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unique = exports.isMitForlobProgram = exports.hasAccess = exports.permissionLevel = exports.PermissionLevels = exports.getTranslation = exports.getTranslationUsingLanguageSelector = exports.getTranslationFromArray = void 0;
function getTranslationFromArray(translations, selectedLanguage, filter, useFirstMatch) {
    return getTranslationUsingLanguageSelector(translations, selectedLanguage, function (translation) { return translation.language; }, filter, useFirstMatch);
}
exports.getTranslationFromArray = getTranslationFromArray;
function getTranslationUsingLanguageSelector(translations, targetLanguage, selector, filter, useFirstMatch) {
    if (!targetLanguage || !translations || !translations.length) {
        return undefined;
    }
    // Apply custom filter
    var validEntries = filter ? translations.filter(filter) : translations;
    if (validEntries.length === 0) {
        return undefined;
    }
    // targetLanguage > 'eng' > creation language (the oldest language)
    var validLanguages = [targetLanguage, 'en'];
    if (!validLanguages.includes(selector(validEntries[0]))) {
        validLanguages.push(selector(validEntries[0]));
    }
    // Filter and sort by valid languages
    var matches = validEntries
        .filter(function (translation) { return validLanguages.indexOf(selector(translation)) > -1; })
        .sort(function (n1, n2) { return validLanguages.indexOf(selector(n2)) - validLanguages.indexOf(selector(n1)); });
    // Return the latest match
    if (matches.length > 0) {
        return useFirstMatch ? matches[0] : matches[matches.length - 1];
    }
    // We should never end up here!
    return undefined;
}
exports.getTranslationUsingLanguageSelector = getTranslationUsingLanguageSelector;
function getTranslation(elem, lang) {
    if (!elem || !elem.translations || elem.translations.length === 0) {
        return undefined;
    }
    // Return wanted language
    var primary = elem.translations.filter(function (t) { return t.language === lang; });
    if (primary.length > 0) {
        return __assign(__assign({}, primary[0]), { _id: elem._id });
    }
    // Return fallback on english
    var fallback = elem.translations.filter(function (t) { return t.language === 'en'; });
    if (fallback.length > 0) {
        return __assign(__assign({}, fallback[0]), { _id: elem._id });
    }
    // If everything fails, return whatever we have
    return __assign(__assign({}, elem.translations[0]), { _id: elem._id });
}
exports.getTranslation = getTranslation;
var PermissionLevels;
(function (PermissionLevels) {
    PermissionLevels[PermissionLevels["SUPERADMIN_PERMISSION_LEVEL"] = 600] = "SUPERADMIN_PERMISSION_LEVEL";
    PermissionLevels[PermissionLevels["ADMIN_PERMISSION_LEVEL"] = 500] = "ADMIN_PERMISSION_LEVEL";
    PermissionLevels[PermissionLevels["EDITOR_PERMISSION_LEVEL"] = 400] = "EDITOR_PERMISSION_LEVEL";
    PermissionLevels[PermissionLevels["TRANSLATOR_PERMISSION_LEVEL"] = 300] = "TRANSLATOR_PERMISSION_LEVEL";
    PermissionLevels[PermissionLevels["VIEWER_PERMISSION_LEVEL"] = 201] = "VIEWER_PERMISSION_LEVEL";
    PermissionLevels[PermissionLevels["ENDUSER_PERMISSION_LEVEL"] = 200] = "ENDUSER_PERMISSION_LEVEL";
    PermissionLevels[PermissionLevels["NO_PERMISSION_LEVEL"] = 100] = "NO_PERMISSION_LEVEL";
})(PermissionLevels = exports.PermissionLevels || (exports.PermissionLevels = {}));
function permissionLevel(type) {
    switch (type) {
        case 'SuperAdmin':
            return PermissionLevels.SUPERADMIN_PERMISSION_LEVEL;
        case 'Admin':
            return PermissionLevels.ADMIN_PERMISSION_LEVEL;
        case 'Editor':
            return PermissionLevels.EDITOR_PERMISSION_LEVEL;
        case 'EmbedIntegration':
            return PermissionLevels.EDITOR_PERMISSION_LEVEL;
        case 'Translator':
            return PermissionLevels.TRANSLATOR_PERMISSION_LEVEL;
        case 'ViewerLicense':
            return PermissionLevels.VIEWER_PERMISSION_LEVEL;
        case 'EndUser':
            return PermissionLevels.ENDUSER_PERMISSION_LEVEL;
        case 'NoUser':
            return PermissionLevels.NO_PERMISSION_LEVEL;
        default:
            return PermissionLevels.NO_PERMISSION_LEVEL;
    }
}
exports.permissionLevel = permissionLevel;
function hasAccess(type, level) {
    return permissionLevel(type) >= level;
}
exports.hasAccess = hasAccess;
function isMitForlobProgram(item) {
    return item.typeDescriptor === 'mitforlobPack';
}
exports.isMitForlobProgram = isMitForlobProgram;
// Filter to delete duplicates in array
function unique(value, index, self) {
    return self.indexOf(value) === index;
}
exports.unique = unique;
//# sourceMappingURL=typeUtils.js.map